import { useBrandConfig } from '@/utils/useBrandConfig';
import Image from '../Image/Image';
import { cn } from '@/lib/utils';

export type LogoProps = {
  width?: number;
  height?: number;
  className?: string;
}

export const Logo = ({ className, width, height }: LogoProps) => {
  const brandConfig = useBrandConfig();

  return (
    <Image
      src={brandConfig.logoUrl}
      alt="brand-logo"
      className={cn('object-contain', className)}
      style={{ width: width ?? 130, height: height ?? 42 }}
    />
  )
}